import {
  formatNormalNumber,
  createKpiTileItem,
} from '../../../../utils/helper';
import { KpiHandler, ValueRealizationData } from './types';
import { KpiData } from 'components/redesign/KpiTile/types';

const noOfDepartments: KpiHandler = {
  type: 'KpiTile',
  handler: (data: ValueRealizationData): KpiData => {
    const { noOfDepartments } = data;

    const formattedValue = formatNormalNumber(noOfDepartments);

    return createKpiTileItem('Number of Departments', formattedValue, []);
  },
};

export default noOfDepartments;
